import { useLocation, useParams } from "react-router-dom";
import SurveyLayout from "../../components/SurveyLayout/SurveyLayout";
import SurveyPageUI from "./components/SurveyPageUI";

const Main = () => {
  const { id } = useParams();
  const { pathname } = useLocation();
  
  return (
    <SurveyLayout pathname={pathname} id={id}>
      <SurveyPageUI />
    </SurveyLayout>
  );
};

export default Main;
